import { formatDate } from '@mobalytics/shared';
import dayjs from 'dayjs';

export const getNextTrialPaymentDate = () => {
  const currentDate = dayjs();
  return formatDate(currentDate.add(7, 'days').valueOf(), 'MMMM D, YYYY');
};
